import { useQuery } from "@tanstack/react-query";
import { fetchCalendarMatrix } from "../fetchers/calendarMatrix";

export function useCalendarMatrix(companyKey, fromDate, toDate) {
    return useQuery({
        queryKey: ["calendarMatrix", companyKey, fromDate, toDate],
        queryFn: () => fetchCalendarMatrix(companyKey, fromDate, toDate),
        enabled: !!companyKey && !!fromDate && !!toDate,
        staleTime: 1000 * 60 * 5, // 5 min
    });
}